function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _ from "lodash";
import { useMemo } from "react";
import { CSSLengthSliderEditor, CSSNumberUnitEditor, SDropdownV3 } from "../..";
import { SField } from "../../components";
export const StackPropertyEditor = ({ value, onChangeValue, readOnly, onClickValue })=>{
    var _value_infiniteScrollSpeed;
    const xDistributionExtras = [
        "stretch",
        "space-evenly",
        "space-around",
        "space-between"
    ];
    const yDistributionExtras = [
        "stretch",
        "space-evenly",
        "space-around",
        "space-between"
    ];
    const zDistributionExtras = [
        "stretch"
    ];
    const axisMap = {
        x: "Horizontal",
        y: "Vertical",
        z: "Layered"
    };
    const axisOptions = [
        "x",
        "y",
        "z"
    ].map((axis)=>({
            label: axisMap[axis],
            value: axis
        }));
    const yAxisAlignmentLabelOverrides = {
        start: "Top",
        end: "Bottom"
    };
    const yAxisDistributionLabelOverrides = {
        start: "Left",
        end: "Right"
    };
    const alignmentOptions = useMemo(()=>{
        const baseline = (value === null || value === void 0 ? void 0 : value.axis) == "x" ? [
            "baseline"
        ] : [];
        return [
            "start",
            "center",
            "end",
            "stretch",
            ...baseline
        ].map((crossAxisAlignment)=>({
                label: ((value === null || value === void 0 ? void 0 : value.axis) != "y" ? yAxisAlignmentLabelOverrides[crossAxisAlignment] : yAxisDistributionLabelOverrides[crossAxisAlignment]) || _.startCase(crossAxisAlignment),
                value: crossAxisAlignment
            }));
    }, [
        value === null || value === void 0 ? void 0 : value.axis
    ]);
    const wrapOptions = [
        "nowrap",
        "wrap",
        "wrap-reverse"
    ].map((wrap)=>({
            label: wrap == "nowrap" ? "Don't Wrap" : _.startCase(wrap),
            value: wrap
        }));
    const reverseOptions = [
        "true",
        "false"
    ].map((reverse)=>({
            label: reverse == "true" ? "Yes" : "No",
            value: reverse
        }));
    // scroll: T.setEnum(new Set(["none", "horizontal", "vertical", "both"])).optional(),
    // scrollBehavior: T.setEnum(new Set(["normal", "paging", "snap"])).optional(),
    // snapPosition: T.setEnum(new Set(["start", "center", "end"])).optional(),
    const scrollOptions = [
        "none",
        "normal",
        "paging",
        "infinite"
    ].map((scroll)=>({
            label: scroll == "none" ? "No Scroll" : _.startCase(scroll),
            value: scroll
        }));
    const snapPositionOptions = [
        "start",
        "center",
        "end"
    ].map((snapPosition)=>({
            label: _.startCase(snapPosition),
            value: snapPosition
        }));
    const autoAdvancePageOptions = [
        "enabled",
        "disabled"
    ].map((autoAdvancePage)=>({
            label: _.startCase(autoAdvancePage),
            value: autoAdvancePage
        }));
    const setProps = (newProps)=>{
        let props = {
            type: "property-stack",
            axis: "x",
            reverse: false,
            crossAxisAlignment: "start",
            mainAxisDistribution: "start",
            wrap: "nowrap",
            gap: "8px",
            scroll: "none",
            snapPosition: "center",
            autoAdvancePageEnabled: undefined,
            autoAdvancePageDelayS: undefined,
            infiniteScrollSpeed: undefined
        };
        if ((newProps === null || newProps === void 0 ? void 0 : newProps.axis) && newProps.axis == "z" && (xDistributionExtras.includes((value === null || value === void 0 ? void 0 : value.mainAxisDistribution) || "") || yDistributionExtras.includes((value === null || value === void 0 ? void 0 : value.mainAxisDistribution) || "")) && !zDistributionExtras.includes((value === null || value === void 0 ? void 0 : value.mainAxisDistribution) || "")) {
            newProps.mainAxisDistribution = "start";
        }
        // if (newProps?.axis && newProps.axis == "y" && value?.mainAxisDistribution == "stretch") {
        //   newProps.mainAxisDistribution = "start"
        // }
        if ((newProps === null || newProps === void 0 ? void 0 : newProps.axis) && newProps.axis != "x" && (value === null || value === void 0 ? void 0 : value.crossAxisAlignment) == "baseline") {
            newProps.crossAxisAlignment = "start";
        }
        onChangeValue && onChangeValue(_object_spread({}, props, value, newProps));
    };
    const onInputChange = (e)=>{
        e.preventDefault();
        setProps({
            gap: `${e.target.value}px`
        });
    };
    const distributionOptions = useMemo(()=>{
        return [
            "start",
            "center",
            "end",
            ...(value === null || value === void 0 ? void 0 : value.axis) == "z" ? zDistributionExtras : [],
            ...(value === null || value === void 0 ? void 0 : value.axis) == "x" ? xDistributionExtras : [],
            ...(value === null || value === void 0 ? void 0 : value.axis) == "y" ? yDistributionExtras : []
        ].map((mainAxisDistribution)=>{
            if ((value === null || value === void 0 ? void 0 : value.axis) != "z" && mainAxisDistribution == "stretch") {
                return {
                    label: "Fill Equally",
                    value: mainAxisDistribution
                };
            }
            if ((value === null || value === void 0 ? void 0 : value.axis) == "y") {
                return {
                    label: yAxisAlignmentLabelOverrides[mainAxisDistribution] || _.startCase(mainAxisDistribution),
                    value: mainAxisDistribution
                };
            }
            return {
                label: yAxisDistributionLabelOverrides[mainAxisDistribution] || _.startCase(mainAxisDistribution),
                value: mainAxisDistribution
            };
        });
    }, [
        value === null || value === void 0 ? void 0 : value.axis
    ]);
    // converts a string like 7px or 10% to {value, unit} (not knowing what the units are)
    const parseLength = (length)=>{
        if (!length) {
            return {
                type: "css-length",
                value: 0,
                unit: "px"
            };
        }
        const match = length.match(/^(\d+)(.*)$/);
        if (!match) {
            return {
                type: "css-length",
                value: 0,
                unit: "px"
            };
        }
        return {
            type: "css-length",
            value: parseInt(match[1]),
            unit: match[2] || "px"
        };
    };
    const getSizeNeededToScroll = (val)=>{
        if (!val) {
            return "";
        }
        if (val.axis === "x") {
            return "width";
        }
        if (val.axis === "y") {
            return "height";
        }
        return "";
    };
    // const [gap, setGap] = useState(parseLength(value?.gap))
    const gap = useMemo(()=>parseLength(value === null || value === void 0 ? void 0 : value.gap), [
        value === null || value === void 0 ? void 0 : value.gap
    ]);
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(SField, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-1 gap-2",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-3 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Axis"
                                        }),
                                        /*#__PURE__*/ _jsx(SDropdownV3, {
                                            borderless: false,
                                            options: axisOptions,
                                            value: axisOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.axis)),
                                            onChange: (axis)=>{
                                                setProps({
                                                    axis: axis.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: `flex ${(value === null || value === void 0 ? void 0 : value.axis) == "y" ? "flex-col-reverse" : "flex-col"} gap-2`,
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grid grid-cols-2 gap-3 items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: (value === null || value === void 0 ? void 0 : value.axis) == "y" ? "Horizontal" : "Vertical"
                                                }),
                                                /*#__PURE__*/ _jsx(SDropdownV3, {
                                                    borderless: false,
                                                    options: alignmentOptions,
                                                    value: alignmentOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.crossAxisAlignment)),
                                                    onChange: (crossAxisAlignment)=>{
                                                        setProps({
                                                            crossAxisAlignment: crossAxisAlignment.value
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grid grid-cols-2 gap-3 items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: (value === null || value === void 0 ? void 0 : value.axis) == "y" ? "Vertical" : "Horizontal"
                                                }),
                                                /*#__PURE__*/ _jsx(SDropdownV3, {
                                                    borderless: false,
                                                    options: distributionOptions,
                                                    value: distributionOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.mainAxisDistribution)),
                                                    onChange: (mainAxisDistribution)=>{
                                                        setProps({
                                                            mainAxisDistribution: mainAxisDistribution.value
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (value === null || value === void 0 ? void 0 : value.axis) != "z" && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-3 items-center",
                                    children: [
                                        "Spacing",
                                        /*#__PURE__*/ _jsx(CSSLengthSliderEditor, {
                                            value: gap,
                                            onChangeValue: (gap)=>{
                                                setProps({
                                                    gap: `${gap === null || gap === void 0 ? void 0 : gap.value}${gap === null || gap === void 0 ? void 0 : gap.unit}`
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-3 items-center",
                                    children: [
                                        "Wrap",
                                        /*#__PURE__*/ _jsx(SDropdownV3, {
                                            borderless: false,
                                            options: wrapOptions,
                                            value: wrapOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.wrap)),
                                            onChange: (wrap)=>{
                                                setProps({
                                                    wrap: wrap.value
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        (value === null || value === void 0 ? void 0 : value.axis) != "z" && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-3 items-center",
                                    children: [
                                        "Scroll",
                                        /*#__PURE__*/ _jsx(SDropdownV3, {
                                            borderless: false,
                                            options: scrollOptions,
                                            value: scrollOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.scroll)) || scrollOptions[0],
                                            onChange: (scroll)=>{
                                                setProps({
                                                    scroll: scroll.value
                                                });
                                            }
                                        })
                                    ]
                                }),
                                (value === null || value === void 0 ? void 0 : value.scroll) === "paging" && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grid grid-cols-2 gap-3 items-center",
                                            children: [
                                                "Snap Position",
                                                /*#__PURE__*/ _jsx(SDropdownV3, {
                                                    borderless: false,
                                                    options: snapPositionOptions,
                                                    value: snapPositionOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.snapPosition)) || snapPositionOptions[1],
                                                    onChange: (snapPosition)=>{
                                                        setProps({
                                                            snapPosition: snapPosition.value
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "grid grid-cols-2 gap-3 items-center",
                                            children: [
                                                "Auto Paging",
                                                /*#__PURE__*/ _jsx(SDropdownV3, {
                                                    borderless: false,
                                                    options: autoAdvancePageOptions,
                                                    value: autoAdvancePageOptions.find((option)=>option.value == (value === null || value === void 0 ? void 0 : value.autoAdvancePageEnabled)) || autoAdvancePageOptions[1],
                                                    onChange: (autoAdvancePageEnabled)=>{
                                                        setProps({
                                                            autoAdvancePageEnabled: autoAdvancePageEnabled.value
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        (value === null || value === void 0 ? void 0 : value.autoAdvancePageEnabled) === "enabled" && /*#__PURE__*/ _jsxs("div", {
                                            className: "grid grid-cols-2 gap-3 items-center",
                                            children: [
                                                "Paging Delay",
                                                /*#__PURE__*/ _jsx(CSSNumberUnitEditor, {
                                                    label: "Delay",
                                                    unit: "s",
                                                    placeholder: "5",
                                                    value: {
                                                        type: "css-number-unit",
                                                        value: (value === null || value === void 0 ? void 0 : value.autoAdvancePageDelayS) || "",
                                                        unit: "s"
                                                    },
                                                    onChangeValue: (delayMs)=>{
                                                        if (typeof delayMs === "undefined") {
                                                            setProps({
                                                                autoAdvancePageDelayS: undefined
                                                            });
                                                            return;
                                                        }
                                                        setProps({
                                                            autoAdvancePageDelayS: delayMs.value
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (value === null || value === void 0 ? void 0 : value.scroll) === "infinite" && /*#__PURE__*/ _jsxs("div", {
                                    className: "grid grid-cols-2 gap-3 items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Infinite Scroll Speed"
                                        }),
                                        /*#__PURE__*/ _jsx(CSSNumberUnitEditor, {
                                            label: "Speed",
                                            unit: "px/frame",
                                            placeholder: "3",
                                            value: {
                                                type: "css-number-unit",
                                                value: (value === null || value === void 0 ? void 0 : (_value_infiniteScrollSpeed = value.infiniteScrollSpeed) === null || _value_infiniteScrollSpeed === void 0 ? void 0 : _value_infiniteScrollSpeed.toString()) || "3",
                                                unit: "px/frame"
                                            },
                                            onChangeValue: (speed)=>{
                                                if (typeof speed === "undefined" || speed.value === "") {
                                                    setProps({
                                                        infiniteScrollSpeed: 0
                                                    }) // Set to 0 when input is empty
                                                    ;
                                                    return;
                                                }
                                                const parsedSpeed = parseFloat(speed.value);
                                                if (isNaN(parsedSpeed)) {
                                                    setProps({
                                                        infiniteScrollSpeed: 0
                                                    }) // Set to 0 for invalid input
                                                    ;
                                                } else {
                                                    setProps({
                                                        infiniteScrollSpeed: parsedSpeed
                                                    });
                                                }
                                            }
                                        })
                                    ]
                                }),
                                (value === null || value === void 0 ? void 0 : value.scroll) && (value === null || value === void 0 ? void 0 : value.scroll) !== "none" && /*#__PURE__*/ _jsxs("p", {
                                    className: "text-sm opacity-50",
                                    children: [
                                        "Be sure to set a ",
                                        getSizeNeededToScroll(value),
                                        " under Size for scrolling to work."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
